import { render, staticRenderFns } from "./departmentSelect.vue?vue&type=template&id=1e23b4ce&scoped=true&"
import script from "./departmentSelect.vue?vue&type=script&lang=js&"
export * from "./departmentSelect.vue?vue&type=script&lang=js&"
import style0 from "./departmentSelect.vue?vue&type=style&index=0&id=1e23b4ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e23b4ce",
  null
  
)

export default component.exports